export type LogLevel = 'log' | 'info' | 'warn' | 'error';

interface LogMessage {
    level: LogLevel;
    message: string;
    timestamp: string;
    stack?: string;
    metadata?: Record<string, unknown>;
}

class Logger {
    private static formatLog(
        level: LogLevel,
        message: string,
        metadata?: Record<string, unknown>,
    ): LogMessage {
        return {
            level,
            message,
            timestamp: new Date().toISOString(),
            metadata,
            ...(level === 'error' ? { stack: new Error().stack } : {}),
        };
    }

    private static formatForConsole(logData: LogMessage): string {
        const { level, timestamp, message, metadata } = logData;
        return `[${level.toUpperCase()}][${timestamp}]:: ${message}${metadata ? `, ${JSON.stringify(metadata)}` : ''}`;
    }

    public static log(message: string, metadata?: Record<string, unknown>): void {
        const logData = Logger.formatLog('log', message, metadata);
        console.log(Logger.formatForConsole(logData));
    }

    public static info(message: string, metadata?: Record<string, unknown>): void {
        const logData = Logger.formatLog('info', message, metadata);
        console.info(Logger.formatForConsole(logData));
    }

    public static warn(message: string, metadata?: Record<string, unknown>): void {
        const logData = Logger.formatLog('warn', message, metadata);
        console.warn(Logger.formatForConsole(logData));
    }

    public static error(message: string, metadata?: Record<string, unknown>): void {
        const logData = Logger.formatLog('error', message, metadata);
        console.error(Logger.formatForConsole(logData));
    }
}

export default Logger;
